import React from 'react'
import Header from "../Sub/Header";
import Footer from "../Sub/Footer";
import GSTSection from '../Sub/GSTSection'
import WhyInvest from '../Sub/WhyInvest';
import CallBack from '../Sub/CallBack';
import FaqSection from "../Sub/FaqSection"

function gst() {
  return (
    <>
      <Header  />
     <GSTSection />
     <WhyInvest />
     <CallBack />
     <FaqSection />
     <Footer />
     
    </>
  )
}

export default gst
